import styled from "styled-components";
import Sizes from "../../Assets/Sizes";
import {RadioGroup} from '@material-ui/core';
import {Button} from "rmwc/Button/index";

const CenterContainer = styled.div`
    z-index: 1;
    text-align: center;
    width: 100%;
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${Sizes.defaultPadding};
`;

const TwoWaysCenterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

const ColumnFlexContainer = styled(FlexContainer)`
    flex-direction: column;
    gap: ${Sizes.mediumPadding};
`;


const PlainColumnFlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Sizes.mediumPadding};
`;

const VerticalSpace = styled.div`
    width: 100%;
    height: ${Sizes.defaultPadding};
`;


const TextContainer = styled.div`
    width: 100%;
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
    flex-grow: 1;
    // margin-top: -150px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    *:focus {
        outline: none;
    }
`;

const TextWithIconWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const PhoneInputWrapper = styled.div`
    width: 100%;
    display: flex;
`;

const ColumnContainer = styled.div`
    display: flex;
    width: 100%;
    gap: ${Sizes.defaultPadding};
`

const PlainContainer = styled.div`
    width: 100%;
    padding-left: ${Sizes.defaultPadding};
    padding-right: ${Sizes.defaultPadding};
`


const AdaptedRadioGroup = styled(RadioGroup)`
    * {
        font-family: var(--app-font);
    }

    .MuiRadio-colorSecondary.Mui-checked, .MuiRadio-root {
        color: ${p => p.theme.colors.primaryTextInverted} !important;
    }
    
    .MuiFormControlLabel-label {
        color: ${p => p.theme.colors.primaryTextInverted} !important;
    }
`


const ModalPrimary = styled(Button).attrs({
    className: 'existing-meetings-dialog__primary-button',
})`
  height: auto;
  padding-top: ${Sizes.smallMargin};
  padding-bottom: ${Sizes.smallMargin};
  background-color: ${p => p.theme.colors.modalPrimaryColor} !important;
  color: ${p => p.theme.colors.modalPrimaryColorInverted} !important;
  border-radius: ${Sizes.defaultBorderRadius};
  font-weight: 400;

  a {
    color: ${p => p.theme.colors.modalPrimaryColorInverted} !important;
  }
`;



export {
    PlainColumnFlexContainer,
    CenterContainer,
    TextContainer,
    TextWithIconWrapper,
    PhoneInputWrapper,
    FlexContainer,
    ColumnFlexContainer,
    VerticalSpace,
    ColumnContainer,
    AdaptedRadioGroup,
    PlainContainer,
    ModalPrimary,
    TwoWaysCenterContainer
}
